import colors from 'styles/colors';

export default {
  baseStyle: {
    fontWeight: 'normal',
    color: colors.black,
  },
  defaultProps: {
    variant: 'default',
  },
  variants: {
    default: {
      bg: colors.blueGrey[100],
      color: 'inherit',
      _active: {
        background: colors.blueGrey[400],
        color: 'inherit',
      },
      _hover: {
        background: colors.blueGrey[300],
        color: 'inherit',
        _disabled: {
          opacity: 0.4,
          bg: colors.blueGrey[200],
        },
      },
    },
    outlineNegative: {
      color: colors.white,
      background: 'none',
      border: '1px solid',
      borderColor: colors.white,
      _active: {
        background: colors.white,
        color: colors.orange[500],
      },
      _hover: {
        background: colors.white,
        color: colors.orange[500],
      },
    },
    outline: {
      color: colors.black,
      background: 'none',
      borderColor: colors.orange[500],
      _active: {
        background: colors.orange[200],
        color: colors.black,
      },
      _hover: {
        background: colors.orange[200],
        color: colors.black,
        _disabled: {
          opacity: 0.4,
          bg: 'none',
        },
      },
    },
    primary: {
      color: colors.black,
      background: colors.orange[500],
      borderColor: colors.orange[500],
      _active: {
        background: colors.orange[700],
        color: colors.black,
      },
      _hover: {
        background: colors.orange[700],
        color: colors.black,
        _disabled: {
          opacity: 0.4,
          bg: colors.orange[500],
        },
      },
    },
    secondary: {
      color: colors.white,
      background: colors.blueGrey[800],
      borderColor: colors.blueGrey[800],
      _active: {
        background: colors.blueGrey[900],
        color: colors.white,
      },
      _hover: {
        background: colors.blueGrey[900],
        color: colors.white,
        _disabled: {
          opacity: 0.4,
          bg: colors.blueGrey[800],
        },
      },
    },
    critical: {
      color: colors.white,
      background: colors.red[600],
      borderColor: colors.red[600],
      _active: {
        background: colors.red[800],
        color: colors.white,
      },
      _hover: {
        background: colors.red[800],
        color: colors.white,
        _disabled: {
          opacity: 0.4,
          bg: colors.red[600],
        },
      },
    },
  },
};
